/**
 * RUM — reports the 5 Core Web Vitals with attribution to GA4 (G-CFTDVKMRCN)
 * as `web_vitals` events. gtag('config') runs at parse time in master.blade.php,
 * ahead of this deferred module, so no event is dropped as "before config".
 * Attribution field names are the v5 API — they differ from v3/v4.
 */
import { onLCP, onINP, onCLS, onFCP, onTTFB } from 'web-vitals/attribution';

(function () {
    'use strict';

    // Sampling rate. 100% to start — current traffic is well within GA4 limits
    // and the low-traffic branch/coupon pages need every sample. Dial down here
    // if event volume ever grows.
    var SAMPLE_RATE = 1;
    if (Math.random() >= SAMPLE_RATE && SAMPLE_RATE < 1) return;

    // Defensive stub: gtag is already defined + configured at parse time in
    // master.blade.php. Re-declare the standard stub only in case this module
    // somehow runs first (e.g. the inline block is ever removed) so calls still
    // queue into dataLayer rather than throw.
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

    // Per-session context attached to every metric for segmentation in GA4.
    var conn = navigator.connection || {};
    var ctx = {
        page_template: (document.body && document.body.dataset.pageType) || 'unknown',
        locale: document.documentElement.lang || '',
        effective_connection: conn.effectiveType || '',
        device_memory: navigator.deviceMemory || '',
        cpu_cores: navigator.hardwareConcurrency || '',
    };

    function report(metric) {
        var a = metric.attribution || {};
        // The "what to blame" selector, per metric (v5 field names):
        //   LCP -> target | CLS -> largestShiftTarget | INP -> interactionTarget
        // (FCP/TTFB have no element — target stays empty.)
        var target = a.target || a.largestShiftTarget || a.interactionTarget || '';
        // GA4 custom metrics are integers. CLS is a 0..~1 float, so scale x1000
        // (0.11 -> 110); ms metrics round to whole milliseconds.
        var scale = metric.name === 'CLS' ? 1000 : 1;
        window.gtag('event', 'web_vitals', Object.assign({
            metric_name: metric.name,                              // LCP/INP/CLS/FCP/TTFB
            metric_value: Math.round(metric.value * scale),        // numeric -> GA4 epn.*
            metric_delta: Math.round(metric.delta * scale),
            metric_rating: metric.rating,                          // good / needs-improvement / poor
            metric_id: metric.id,                                  // per-page-load unique id
            metric_navigation_type: metric.navigationType || '',   // navigate / reload / back-forward / ...
            attr_target: String(target).slice(0, 100),             // shifting/slow/LCP element selector
            attr_event_type: a.interactionType || '',              // INP: pointer / keyboard
            attr_load_state: a.loadState || '',                    // doc load state at the event
        }, ctx));
    }

    onLCP(report);
    onINP(report);
    onCLS(report);
    onFCP(report);
    onTTFB(report);
})();
